module.exports = function anonymous(locals, filters, escape, rethrow) {
    escape = escape || function(html) {
        return String(html).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
    };
    var __stack = {
        lineno: 1,
        input: '<span class="greycmg"><%= clubName %></span>\n<% if (studioName) { %>\n<span class="orangecmg"><%= studioName %></span>\n<% } %>\n',
        filename: "."
    };
    function rethrow(err, str, filename, lineno) {
        var lines = str.split("\n"), start = Math.max(lineno - 3, 0), end = Math.min(lines.length, lineno + 3);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    }
    try {
        var buf = [];
        with (locals || {}) {
            (function() {
                buf.push('<span class="greycmg">', escape((__stack.lineno = 1, clubName)), "</span>\n");
                __stack.lineno = 2;
                if (studioName) {
                    buf.push('\n<span class="orangecmg">', escape((__stack.lineno = 3, studioName)), "</span>\n");
                    __stack.lineno = 4;
                }
                buf.push("\n");
            })();
        }
        return buf.join("");
    } catch (err) {
        rethrow(err, __stack.input, __stack.filename, __stack.lineno);
    }
}


//////////////////
// WEBPACK FOOTER
// /home/app/terminal/release/1714127418-2.1.11/node_modules/ejs-compiled-loader!./src/templates/header_club.ejs
// module id = 129
// module chunks = 0